import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/web.timers.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx } from "react/jsx-runtime";
/*global $*/

import React from "react";
import { currentCmsCompanyId } from "@/common/fhtGlobalEnv";

var BroadsideNotification =
/** @class */
function (_super) {
  __extends(BroadsideNotification, _super);

  function BroadsideNotification() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      originalTitle: document.title
    };
    _this.myRef = /*#__PURE__*/React.createRef();

    _this.applyShakeEffect = function ($root) {
      var self = _this;
      $root.queue(function () {
        document.title = "您有新消息(" + self.props.totalUnreadMessageCount + ")";
        $(this).dequeue();
      }).fadeIn("500").queue(function () {
        document.title = self.state.originalTitle;
        $(this).dequeue();
      }).fadeOut("500", function () {
        if (self.props.totalUnreadMessageCount) {
          setTimeout(self.applyShakeEffect, 0, $root);
        }
      });
    };

    return _this;
  }

  BroadsideNotification.prototype.componentDidUpdate = function (prevProps, prevState) {
    var $root = $(this.myRef.current);

    if (this.props.totalUnreadMessageCount) {
      this.applyShakeEffect($root);
    } else {
      $root.finish(); // note that calling finish will only finish all animations,
      // but will skip non-animation queue functions, hence we reset document.title below.

      document.title = this.state.originalTitle;
    }
  };

  BroadsideNotification.prototype.render = function () {
    var isInCms = Boolean(currentCmsCompanyId);
    var messageCount = this.props.totalUnreadMessageCount;
    return _jsx("div", {
      children: !!messageCount && !isInCms && _jsx("div", __assign({
        ref: this.myRef,
        className: "broadside-tool__notification"
      }, {
        children: messageCount > 99 ? 99 + "+" : messageCount
      }), void 0)
    }, void 0);
  };

  return BroadsideNotification;
}(React.Component);

export default BroadsideNotification;